export class cfRegionLinks {
    // static genCustomToken = "https://europe-west1-mona-ai-pwa-firebase.cloudfunctions.net/generateCustomToken-west1";
    static genCustomToken = "https://europe-west3-mona-ai-pwa-firebase.cloudfunctions.net/generateCustomToken";

    static loginPlatform = "https://europe-west1-mona-ai-pwa-firebase.cloudfunctions.net/LoginPlatform-west1";
    // static loginPlatform = "https://europe-west3-mona-ai-pwa-firebase.cloudfunctions.net/LoginPlatform";

    // static getDataCreateProfile = "https://europe-west1-mona-ai-pwa-firebase.cloudfunctions.net/getDataCreateProfile-west1";
    static getDataCreateProfile = "https://europe-west3-mona-ai-pwa-firebase.cloudfunctions.net/getDataCreateProfile";

    // static googleDetectLanguage = "https://europe-west1-mona-ai-pwa-firebase.cloudfunctions.net/GoogleDetectLanguage-west1";
    static googleDetectLanguage = "https://europe-west3-mona-ai-pwa-firebase.cloudfunctions.net/GoogleDetectLanguage";

    // static googleTranslateText = "https://europe-west1-mona-ai-pwa-firebase.cloudfunctions.net/GoogleTranslateText-west1";
    static googleTranslateText = "https://europe-west3-mona-ai-pwa-firebase.cloudfunctions.net/GoogleTranslateText";

    // static deeplCheckLanguageOrigin = "https://europe-west1-mona-ai-pwa-firebase.cloudfunctions.net/deeplCheckLanguageOrigin-west1";
    static deeplCheckLanguageOrigin = "https://europe-west3-mona-ai-pwa-firebase.cloudfunctions.net/deeplCheckLanguageOrigin";

    // static classifyAndExtractDoc = "https://europe-west1-mona-ai-pwa-firebase.cloudfunctions.net/classifyAndExtractDoc-west1";
    static classifyAndExtractDoc = "https://europe-west3-mona-ai-pwa-firebase.cloudfunctions.net/classifyAndExtractDoc";

    // static logoToPdf2 = "https://europe-west1-mona-sales.cloudfunctions.net/logsToPdf2-west1";
    static logoToPdf2 = "https://europe-west3-mona-sales.cloudfunctions.net/logsToPdf2";

    // static calendarHandler = "https://europe-west1-mona-ai-pwa-firebase.cloudfunctions.net/calendarHandler-west1";
    static calendarHandler = "https://europe-west3-mona-ai-pwa-firebase.cloudfunctions.net/calendarHandler";

    // static microsoftCalendarHandler = "https://europe-west1-mona-ai-pwa-firebase.cloudfunctions.net/microsoftCalendarHandler-west1";
    static microsoftCalendarHandler = "https://europe-west3-mona-ai-pwa-firebase.cloudfunctions.net/microsoftCalendarHandler";

    // static getAllHubspotData = "https://europe-west1-mona-ai-pwa.cloudfunctions.net/getAllHubspotData-west1";
    static getAllHubspotData = "https://europe-west3-mona-ai-pwa.cloudfunctions.net/getAllHubspotData";

    // static getOAuthTokens = "https://europe-west1-mona-test1.cloudfunctions.net/get_oauth_tokens-west1";
    static getOAuthTokens = "https://europe-west3-mona-test1.cloudfunctions.net/get_oauth_tokens";

    // static fetchLogoAndCrawl = "https://europe-west1-mona-ai-pwa-firebase.cloudfunctions.net/fetchLogoAndCrawl-west1";
    static fetchLogoAndCrawl = "https://europe-west3-mona-ai-pwa-firebase.cloudfunctions.net/fetchLogoAndCrawl";

    // static deleteUserMonaPlattform = "https://europe-west1-mona-ai-pwa-firebase.cloudfunctions.net/delete-user-mona-plattform-west1";
    static deleteUserMonaPlattform = "https://europe-west3-mona-ai-pwa-firebase.cloudfunctions.net/delete-user-mona-plattform";

    // static deactivateUserMonaPlattform = "https://europe-west1-mona-ai-pwa-firebase.cloudfunctions.net/deactivate-user-mona-plattform-west1";
    static deactivateUserMonaPlattform = "https://europe-west3-mona-ai-pwa-firebase.cloudfunctions.net/deactivate-user-mona-plattform";

    // @deprecated - Use secure endpoint via api.mona-ai.cloud/auth/sendVerificationEmail with Bearer token instead
    // static sendRegisterEmail = "https://europe-west1-mona-ai-pwa-firebase.cloudfunctions.net/sendRegisterEmail-west1";
    static sendRegisterEmail = "https://europe-west3-mona-ai-pwa-firebase.cloudfunctions.net/sendRegisterEmail";

    static sendAccountDeletionEmail = "https://europe-west3-mona-ai-pwa-firebase.cloudfunctions.net/sendAccountDeletionEmail";

    static sendTeammemberInviteMail = "https://europe-west3-mona-ai-pwa-firebase.cloudfunctions.net/sendTeammemberInviteMail";

    // Gen 2 HTTP function — SuperAdmin-only, deletes a Firebase Auth entry.
    static deleteAuthUser = "https://delete-user-mona-platform-219198639425.europe-west3.run.app";

}